import { getSelectors, RouterReducerState } from "@ngrx/router-store";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ROOM_INVITATION_FIRST_DISABLE_QUERY_PARAM_NAME } from "@youm-front/room/domain";

const selectRouter = createFeatureSelector<RouterReducerState>("router");
const { selectQueryParam } = getSelectors(selectRouter);

export const disabled = createSelector(
  selectQueryParam(ROOM_INVITATION_FIRST_DISABLE_QUERY_PARAM_NAME),
  (_) => {
    return !!_;
  }
);
